import cookie from "@/cookie"
import { AuthApis } from "@/utils/Videomonster/Api"
import { IsDevAndLocal } from '@/utils/Global'

const KEYS = {
    VM_ACCESS_TOKEN: 'token',
    VM_REFRESH_TOKEN: 'refreshtoken',
    VM_ACCESS_ADMIN_TOKEN: 'adminToken',
    CAFE24_ACCESS_TOKEN: 'CFAT',
    CAFE24_REFRESH_TOKEN: 'CFRT',
}

const ClearAllToken = () => {
    Object.keys(KEYS).forEach(key => {
        if (KEYS[key] === KEYS.CAFE24_ACCESS_TOKEN || KEYS[key] === KEYS.CAFE24_REFRESH_TOKEN) cookie.DeleteCookie(KEYS[key])
        else localStorage.removeItem(KEYS[key])
    })
}

const GetToken = () => localStorage.getItem(KEYS.VM_ACCESS_TOKEN)
const SetToken = (accessToken) => localStorage.setItem(KEYS.VM_ACCESS_TOKEN, accessToken)
const RemoveToken = () => { localStorage.removeItem(KEYS.VM_ACCESS_TOKEN) }

const GetRefreshToken = () => localStorage.getItem(KEYS.VM_REFRESH_TOKEN)
const SetRefreshToken = (refreshToken) => localStorage.setItem(KEYS.VM_REFRESH_TOKEN, refreshToken)
const RemoveRefreshToken = () => { localStorage.removeItem(KEYS.VM_REFRESH_TOKEN) }

const GetAdminToken = () => localStorage.getItem(KEYS.VM_ACCESS_ADMIN_TOKEN);
const SetAdminToken = (adminToken) => localStorage.setItem(KEYS.VM_ACCESS_ADMIN_TOKEN, adminToken)

const GetCafe24AccessToken = async () => {
    try {
        let cftoken = cookie.GetCookie(KEYS.CAFE24_ACCESS_TOKEN)
        const cfrefreshtoken = GetCafe24RefreshToken();
        if (!cfrefreshtoken || cfrefreshtoken === "undefined") return null;

        if (!cftoken) {
            if (IsDevAndLocal() && cfrefreshtoken === "TEST_CAFE24_REFRESH_TOKEN") {
                alert("테스트용 카페 24 토큰을 재발급함")
                SetCafe24AccessToken("TEST_CAFE24_ACCESS_TOKEN", "2099-09-26T16:46:25.000")
                SetCafe24RefreshToken("TEST_CAFE24_REFRESH_TOKEN", "2099-09-26T16:46:25.000")
                return "TEST_CAFE24_ACCESS_TOKEN"
            }

            const accessToken = GetToken()
            const mallId = sessionStorage.getItem("mid");
            const { result, data } = await AuthApis.UpdateCafe24RefreshToken(accessToken, { mallId, cfrefreshtoken })
            if (result) {
                const { accessToken, expiresAt, refreshToken, refreshTokenExpiresAt } = data;
                cftoken = accessToken;
                SetCafe24AccessToken(accessToken, expiresAt);
                SetCafe24RefreshToken(refreshToken, refreshTokenExpiresAt)
            }
        }
        return cftoken;
    } catch (e) {
        return null;
    }
};
const SetCafe24AccessToken = (accessToken, expAt) => {
    const date = new Date(expAt);
    date.setHours(date.getHours() + 9);
    date.setMinutes(date.getMinutes() - 10);
    cookie.SetCookie(KEYS.CAFE24_ACCESS_TOKEN, accessToken, date - new Date())
}
const RemoveCafe24AccessToken = () => { cookie.DeleteCookie(KEYS.CAFE24_ACCESS_TOKEN) }

const GetCafe24RefreshToken = () => cookie.GetCookie(KEYS.CAFE24_REFRESH_TOKEN)
const SetCafe24RefreshToken = (refreshToken, expAt) => {
    const date = new Date(expAt);
    date.setHours(date.getHours() + 9);
    date.setMinutes(date.getMinutes() - 10);
    cookie.SetCookie(KEYS.CAFE24_REFRESH_TOKEN, refreshToken, date - new Date())
}
const RemoveCafe24RefreshToken = () => { cookie.DeleteCookie(KEYS.CAFE24_REFRESH_TOKEN) }
export default {
    ClearAllToken,

    GetToken,
    SetToken,
    RemoveToken,

    GetRefreshToken,
    SetRefreshToken,
    RemoveRefreshToken,

    GetAdminToken,
    SetAdminToken,

    GetCafe24AccessToken,
    SetCafe24AccessToken,
    RemoveCafe24AccessToken,

    GetCafe24RefreshToken,
    SetCafe24RefreshToken,
    RemoveCafe24RefreshToken
}